import React from 'react';
import Game from './components/Game/Game';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>2048</h1>
      </header>
      <main>
        <Game />
      </main>
    </div>
  );
}

export default App;
